/* Page to edit a Callsheet
 * Contains the SchedulePage component and the AddCast and
   AddBackGround form components to add the cast and BG call times
   These are seperate forms to the main Callsheet form
 * Contains the Form components to add each department crew call times:
   AddProduction, AddCamera, AddCastingAD, AddLocations, AddWardrobe, AddScriptCater, AddElectricGrip,
   AddMakeup, AddArt, AddSoundTransport, AddStunts and AddPostAdditional 
 * The sidebyside value allows the schedule and the addCast components 
   to be viewed on the same page */
import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Dropdown } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import { useHistory, useParams } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import TopBox from "../../components/TopBox";
import { useRedirect } from "../../hooks/Redirect";
import { useCrewInfoContext } from "../../contexts/BaseCallContext";
import AddCast from "./CallsheetAddCast";
import SchedulePage from "./callsheetSchedule/SchedulePage";
import AddBackGround from "./CallsheetAddBackGround";

import AddProduction from './callsheetAddCrewTimes/AddProduction';
import AddCamera from './callsheetAddCrewTimes/AddCamera';
import AddLocations from './callsheetAddCrewTimes/AddLocations';
import AddWardrobe from './callsheetAddCrewTimes/AddWardrobe';
import AddElectricGrip from './callsheetAddCrewTimes/AddElectricGrip';
import AddMakeup from './callsheetAddCrewTimes/AddMakeup';
import AddArt from './callsheetAddCrewTimes/AddArt';
import AddStunts from './callsheetAddCrewTimes/AddStunts';
import AddCater from './callsheetAddCrewTimes/AddCater';
import AddADPA from './callsheetAddCrewTimes/AddADPA';
import AddTransport from './callsheetAddCrewTimes/AddTransport';
import AddConWrang from './callsheetAddCrewTimes/AddConWrang';
import AddTv from './callsheetAddCrewTimes/AddTv';
import AddCasting from './callsheetAddCrewTimes/AddCasting';
import AddScript from "./callsheetAddCrewTimes/AddScript";
import AddSound from './callsheetAddCrewTimes/AddSound';
import AddPost from './callsheetAddCrewTimes/AddPost';

import InformationEdit from "./info/InformationEdit";
import ImportantCrewCalls from "./info/ImportantCrewCalls";
import InfoCrewCalls from "./info/InfoCrewCalls";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import toast from "react-hot-toast"; 
import styles from "../../styles/Callsheets.module.css";
import btnStyles from "../../styles/Button.module.css";
import axios from "axios";
import AddAddition from "./callsheetAddCrewTimes/AddAdditional";
import { useCurrentUser } from "../../contexts/CurrentUserContext";

const CallsheetEditPage = () => {
  const host = useHostName();
  const currentUser = useCurrentUser();
  useEffect(() => {
        if (
          currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name !== "Superadmin")
        ) {
        history.push(`/${localStorage.getItem("projectSlug")}/signin`);
        } 
        // eslint-disable-next-line
      }, [currentUser]);
  useRedirect();
  const [errors, setErrors] = useState({});
  const [hospitals, setHospitals] = useState({ results: [] })
  const { id } = useParams();
  const history = useHistory();
  const crewInfoOne = useCrewInfoContext();
  const [showSchedule, setShowSchedule] = useState(false);
  const [showAddCast, setShowAddCast] = useState(false);
  const [showAddBg, setShowAddBg] = useState(false);
  const [showSideBySide, setShowSideBySide] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const queryString = window.location.search;
  const [charactersList, setCharactersList] = useState([]);
  const [days, setDays] = useState([]);
  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epiParam = params.get("episode");
  const epi = epiParam && epiParam !== "null" ? epiParam : null;
  // eslint-disable-next-line
  const project = params.get("project");
  // eslint-disable-next-line
  const episodeTitle = params.get("episodeTitle");
  // eslint-disable-next-line
  const [dayData, setDayData] = useState({ results: [] });
  const [scenes, setScenes] = useState({ results: [] });
  const [callsheet_id, setCallsheet_id] = useState({ results: [] });
  const [dataDay, setDataDay] = useState("");
  const [dataDate, setDataDate] = useState("");

  const [showPro, setShowPro] = useState(false);
    const [showCam, setShowCam] = useState(false);
    const [showSou, setShowSou] = useState(false);
    const [showLoc, setShowLoc] = useState(false);
    const [showMak, setShowMak] = useState(false);
    const [showEle, setShowEle] = useState(false);
    const [showScr, setShowScr] = useState(false);
    const [showArt, setShowArt] = useState(false);
    const [showCas, setShowCas] = useState(false);
    const [showStu, setShowStu] = useState(false);
    const [showPos, setShowPos] = useState(false);
    const [showWar, setShowWar] = useState(false);
    const [showCat, setShowCat] = useState(false);
    const [showAD, setShowAD] = useState(false); 
    const [showTra, setShowTra] = useState(false); 
    const [showAdd, setShowAdd] = useState(false);
    const [showTv, setShowTv] = useState(false);
    const [showWra, setShowWra] = useState(false);

  const [showInfo, setShowInfo] = useState(false);
  const [showImportantCrew, setShowImportantCrew] = useState(false);
  const [showInfoCrew, setShowInfoCrew] = useState(false);

  // main callsheet data
  const [postData, setPostData] = useState({
    weather_location: "",
    unit_call: "",
    talent_call: "",
    shoot_call: "",
    breakfast: "",
    lunch: "",
    wrap: "",
    basecamp_name: "",
    basecamp_address: "",
    basecamp_parking_n_notes: "",
    location_1_name: "",
    location_2_name: "",
    location_3_name: "",
    location_4_name: "",
    location_5_name: "",
    location_1_address: "",
    location_2_address: "",
    location_3_address: "",
    location_4_address: "",
    location_5_address: "",
    location_1_parking_n_notes: "",
    location_2_parking_n_notes: "",
    location_3_parking_n_notes: "",
    location_4_parking_n_notes: "",
    location_5_parking_n_notes: "",
    hospital_address_line_4: "",
    important_info: "",
    transport_info: "",
    department_info: "",
    // CALLS
    // production
    director_calltime: "",
    producer_calltime: "",
    pro_coordinator_calltime: "",
    travel_coordinator_calltime: "",
    upm_calltime: "",
    production_pa_calltime: "",
    script_supervisor_calltime: "",
    legal_calltime: "",
    set_medic_calltime: "",
    oth_production_pos_1_calltime: "",
    oth_production_pos_2_calltime: "",
    oth_production_pos_3_calltime: "",
    oth_production_pos_4_calltime: "",
    oth_production_pos_5_calltime: "",
    // art
    production_designer_calltime: "",
    art_director_calltime: "",
    art_assistant_calltime: "",
    set_decorator_calltime: "",
    set_dresser_calltime: "",
    lead_man_calltime: "",
    dresser_calltime: "",
    prop_master_calltime: "",
    ass_prop_master_calltime: "",
    prop_buyer_calltime: "",
    armorer_calltime: "",
    // cam
    dop_calltime: "",
    camera_operator_calltime: "",
    camera_ass_1_calltime: "",
    camera_ass_2_calltime: "",
    dit_calltime: "",
    steadicam_calltime: "",
    camera_pa_calltime: "",
    oth_camera_pos_1_calltime: "",
    oth_camera_pos_2_calltime: "",
    oth_camera_pos_3_calltime: "",
    oth_camera_pos_4_calltime: "",
    oth_camera_pos_5_calltime: "",
    // casting
    casting_director_calltime: "",
    extras_casting_calltime: "",
    ad_1_calltime: "",
    ad_2_calltime: "",
    ad_3_calltime: "",
    ad_4_calltime: "",
    ad_5_calltime: "",
    pro_assistant_1_calltime: "",
    pro_assistant_2_calltime: "",
    pro_assistant_3_calltime: "",
    pro_assistant_4_calltime: "",
    pro_assistant_5_calltime: "",
    // elegrip
    gaffer_calltime: "",
    best_boy_electric_calltime: "",
    electric_3_calltime: "",
    electric_4_calltime: "",
    keygrip_calltime: "",
    best_boy_grip_calltime: "",
    dolly_grip_calltime: "",
    swing_ge1_calltime: "",
    swing_ge2_calltime: "",
    swing_ge3_calltime: "",
    swing_ge4_calltime: "",
    swing_ge5_calltime: "",
    // loc
    location_mngr_calltime: "",
    location_ass_1_calltime: "",
    location_ass_2_calltime: "",
    location_ass_3_calltime: "",
    location_ass_4_calltime: "",
    location_security_calltime: "",
    // mak
    key_hairmakeup_calltime: "",
    key_hairstylist_calltime: "",
    sfx_makeup_calltime: "",
    sfx_makeup_assistant_calltime: "",
    makeup_artist_1_calltime: "",
    makeup_artist_2_calltime: "",
    makeup_artist_3_calltime: "",
    makeup_artist_4_calltime: "",
    makeup_artist_5_calltime: "",
    // post/add-pos
    editor_calltime: "",
    fx_calltime: "",
    add_pos_1_calltime: "",
    add_pos_2_calltime: "",
    add_pos_3_calltime: "",
    add_pos_4_calltime: "",
    add_pos_5_calltime: "",
    add_pos_6_calltime: "",
    add_pos_7_calltime: "",
    add_pos_8_calltime: "",
    add_pos_9_calltime: "",
    add_pos_10_calltime: "",
    add_pos_11_calltime: "",
    add_pos_12_calltime: "",
    add_pos_13_calltime: "",
    add_pos_14_calltime: "",
    add_pos_15_calltime: "",
    add_pos_16_calltime: "",
    add_pos_17_calltime: "",
    add_pos_18_calltime: "",
    add_pos_19_calltime: "",
    add_pos_20_calltime: "",
    // script/cater
    writer_calltime: "",
    catering_co_1_calltime: "",
    catering_co_2_calltime: "",
    catering_co_3_calltime: "",
    craft_service_calltime: "",
    crafty_ass_calltime: "",
    // sound/transport
    sound_mixer_calltime: "",
    boom_operator_calltime: "",
    sound_assistant_1_calltime: "",
    sound_assistant_2_calltime: "",
    transport_captain_calltime: "",
    transport_manager_1_calltime: "",
    transport_manager_2_calltime: "",
    head_driver_calltime: "",
    car1_calltime: "",
    car2_calltime: "",
    car3_calltime: "",
    truck1_calltime: "",
    truck2_calltime: "",
    truck3_calltime: "",
    // stunts
    stunt_coordinator_calltime: "",
    stunts_1_calltime: "",
    stunts_2_calltime: "",
    stunts_3_calltime: "",
    stunts_4_calltime: "",
    stunts_5_calltime: "",
    // wardrobe
    costume_designer_calltime: "",
    ass_costume_designer_calltime: "",
    wardrobe_assistant_1_calltime: "",
    wardrobe_assistant_2_calltime: "",
    wardrobe_assistant_3_calltime: "",
    wardrobe_assistant_4_calltime: "",
    wardrobe_assistant_5_calltime: "",
  });

  const {
    unit_call,
    talent_call,
    shoot_call,
    breakfast,
    lunch,
    wrap,
    basecamp_name,
    basecamp_address,
    basecamp_parking_n_notes,
    location_1_name,
    location_2_name,
    location_3_name,
    location_4_name,
    location_5_name,
    location_1_address,
    location_2_address,
    location_3_address,
    location_4_address,
    location_5_address,
    location_1_parking_n_notes,
    location_2_parking_n_notes,
    location_3_parking_n_notes,
    location_4_parking_n_notes,
    location_5_parking_n_notes,
    hospital_address_line_4,
    weather_location,
    important_info,
    transport_info,
    department_info,
    // production
    director_calltime,
    producer_calltime,
    pro_coordinator_calltime,
    travel_coordinator_calltime,
    upm_calltime,
    production_pa_calltime,
    script_supervisor_calltime,
    legal_calltime,
    set_medic_calltime,
    oth_production_pos_1_calltime,
    oth_production_pos_2_calltime,
    oth_production_pos_3_calltime,
    oth_production_pos_4_calltime,
    oth_production_pos_5_calltime,
    // art
    production_designer_calltime,
    art_director_calltime,
    art_assistant_calltime,
    set_decorator_calltime,
    set_dresser_calltime,
    lead_man_calltime,
    dresser_calltime,
    prop_master_calltime,
    ass_prop_master_calltime,
    prop_buyer_calltime,
    armorer_calltime,
    // cam
    dop_calltime,
    camera_operator_calltime,
    camera_ass_1_calltime,
    camera_ass_2_calltime,
    dit_calltime,
    steadicam_calltime,
    camera_pa_calltime,
    oth_camera_pos_1_calltime,
    oth_camera_pos_2_calltime,
    oth_camera_pos_3_calltime,
    oth_camera_pos_4_calltime,
    oth_camera_pos_5_calltime,
    // casting
    casting_director_calltime,
    extras_casting_calltime,
    ad_1_calltime,
    ad_2_calltime,
    ad_3_calltime,
    ad_4_calltime,
    ad_5_calltime,
    pro_assistant_1_calltime,
    pro_assistant_2_calltime,
    pro_assistant_3_calltime,
    pro_assistant_4_calltime,
    pro_assistant_5_calltime,
    // ele/Grip
    gaffer_calltime,
    best_boy_electric_calltime,
    electric_3_calltime,
    electric_4_calltime,
    keygrip_calltime,
    best_boy_grip_calltime,
    dolly_grip_calltime,
    swing_ge1_calltime,
    swing_ge2_calltime,
    swing_ge3_calltime,
    swing_ge4_calltime,
    swing_ge5_calltime,
    // locations
    location_mngr_calltime,
    location_security_calltime,
    location_ass_1_calltime,
    location_ass_2_calltime,
    location_ass_3_calltime,
    location_ass_4_calltime,
    // makeup
    key_hairmakeup_calltime,
    key_hairstylist_calltime,
    sfx_makeup_calltime,
    sfx_makeup_assistant_calltime,
    makeup_artist_1_calltime,
    makeup_artist_2_calltime,
    makeup_artist_3_calltime,
    makeup_artist_4_calltime,
    makeup_artist_5_calltime,
    // post/add-pos
    editor_calltime,
    fx_calltime,
    add_pos_1_calltime,
    add_pos_2_calltime,
    add_pos_3_calltime,
    add_pos_4_calltime,
    add_pos_5_calltime,
    add_pos_6_calltime,
    add_pos_7_calltime,
    add_pos_8_calltime,
    add_pos_9_calltime,
    add_pos_10_calltime,
    // add-pos 2
    add_pos_11_calltime,
    add_pos_12_calltime,
    add_pos_13_calltime,
    add_pos_14_calltime,
    add_pos_15_calltime,
    add_pos_16_calltime,
    add_pos_17_calltime,
    add_pos_18_calltime,
    add_pos_19_calltime,
    add_pos_20_calltime,
    // script/cater
    writer_calltime,
    catering_co_1_calltime,
    catering_co_2_calltime,
    catering_co_3_calltime,
    craft_service_calltime,
    crafty_ass_calltime,
    // sound/transport
    sound_mixer_calltime,
    boom_operator_calltime,
    sound_assistant_1_calltime,
    sound_assistant_2_calltime,
    transport_captain_calltime,
    transport_manager_1_calltime,
    transport_manager_2_calltime,
    head_driver_calltime,
    car1_calltime,
    car2_calltime,
    car3_calltime,
    truck1_calltime,
    truck2_calltime,
    truck3_calltime,
    // stunts
    stunt_coordinator_calltime,
    stunts_1_calltime,
    stunts_2_calltime,
    stunts_3_calltime,
    stunts_4_calltime,
    stunts_5_calltime,
    // wardrobe
    costume_designer_calltime,
    ass_costume_designer_calltime,
    wardrobe_assistant_1_calltime,
    wardrobe_assistant_2_calltime,
    wardrobe_assistant_3_calltime,
    wardrobe_assistant_4_calltime,
    wardrobe_assistant_5_calltime,
  } = postData;

  // hospital data
  const [postData2, setPostData2] = useState({
    nearest_hospital: "",
    hospital_address_line_1: "",
    hospital_address_line_2: "",
    hospital_address_line_3: "",
    });
  
    const {
    nearest_hospital,
    hospital_address_line_1,
    hospital_address_line_2,
    hospital_address_line_3,
    } = postData2;

    const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  // 1. MAIN CALLSHEET REQUESTS 
  useEffect(() => {
    const handleMount = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const [
            { data: dayGet },
            { data: scenesdata },
            { data: callsheetdata },
            { data: daysData },
          ] = await Promise.all([
            axiosReq.get(`/days/${id}`),
            axiosReq.get(`/schedule/scenes/?day_id=${id}`),
            await axiosReq.get(`/callsheetsnew/?day_id=${id}`),
            axiosReq.get(`days/`),
          ]);
          const {            
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
            director_calltime,
            producer_calltime,
            pro_coordinator_calltime,
            travel_coordinator_calltime,
            upm_calltime,
            production_pa_calltime,
            script_supervisor_calltime,
            legal_calltime,
            set_medic_calltime,
            oth_production_pos_1_calltime,
            oth_production_pos_2_calltime,
            oth_production_pos_3_calltime,
            oth_production_pos_4_calltime,
            oth_production_pos_5_calltime,
            production_designer_calltime,
            art_director_calltime,
            art_assistant_calltime,
            set_decorator_calltime,
            set_dresser_calltime,
            lead_man_calltime,
            dresser_calltime,
            prop_master_calltime,
            ass_prop_master_calltime,
            prop_buyer_calltime,
            armorer_calltime,
            dop_calltime,
            camera_operator_calltime,
            camera_ass_1_calltime,
            camera_ass_2_calltime,
            dit_calltime,
            steadicam_calltime,
            camera_pa_calltime,
            oth_camera_pos_1_calltime,
            oth_camera_pos_2_calltime,
            oth_camera_pos_3_calltime,
            oth_camera_pos_4_calltime,
            oth_camera_pos_5_calltime,
            casting_director_calltime,
            extras_casting_calltime,
            ad_1_calltime,
            ad_2_calltime,
            ad_3_calltime,
            ad_4_calltime,
            ad_5_calltime,
            pro_assistant_1_calltime,
            pro_assistant_2_calltime,
            pro_assistant_3_calltime,
            pro_assistant_4_calltime,
            pro_assistant_5_calltime,
            gaffer_calltime,
            best_boy_electric_calltime,
            electric_3_calltime,
            electric_4_calltime,
            keygrip_calltime,
            best_boy_grip_calltime,
            dolly_grip_calltime,
            swing_ge1_calltime,
            swing_ge2_calltime,
            swing_ge3_calltime,
            swing_ge4_calltime,
            swing_ge5_calltime,
            location_mngr_calltime,
            location_security_calltime,
            location_ass_1_calltime,
            location_ass_2_calltime,
            location_ass_3_calltime,
            location_ass_4_calltime,
            key_hairmakeup_calltime,
            key_hairstylist_calltime,
            sfx_makeup_calltime,
            sfx_makeup_assistant_calltime,
            makeup_artist_1_calltime,
            makeup_artist_2_calltime,
            makeup_artist_3_calltime,
            makeup_artist_4_calltime,
            makeup_artist_5_calltime,
            editor_calltime,
            fx_calltime,
            add_pos_1_calltime,
            add_pos_2_calltime,
            add_pos_3_calltime,
            add_pos_4_calltime,
            add_pos_5_calltime,
            add_pos_6_calltime,
            add_pos_7_calltime,
            add_pos_8_calltime,
            add_pos_9_calltime,
            add_pos_10_calltime,
            add_pos_11_calltime,
            add_pos_12_calltime,
            add_pos_13_calltime,
            add_pos_14_calltime,
            add_pos_15_calltime,
            add_pos_16_calltime,
            add_pos_17_calltime,
            add_pos_18_calltime,
            add_pos_19_calltime,
            add_pos_20_calltime,
            writer_calltime,
            catering_co_1_calltime,
            catering_co_2_calltime,
            catering_co_3_calltime,
            craft_service_calltime,
            crafty_ass_calltime,
            sound_mixer_calltime,
            boom_operator_calltime,
            sound_assistant_1_calltime,
            sound_assistant_2_calltime,
            transport_captain_calltime,
            transport_manager_1_calltime,
            transport_manager_2_calltime,
            head_driver_calltime,
            car1_calltime,
            car2_calltime,
            car3_calltime,
            truck1_calltime,
            truck2_calltime,
            truck3_calltime,
            stunt_coordinator_calltime,
            stunts_1_calltime,
            stunts_2_calltime,
            stunts_3_calltime,
            stunts_4_calltime,
            stunts_5_calltime,
            costume_designer_calltime,
            ass_costume_designer_calltime,
            wardrobe_assistant_1_calltime,
            wardrobe_assistant_2_calltime,
            wardrobe_assistant_3_calltime,
            wardrobe_assistant_4_calltime,
            wardrobe_assistant_5_calltime,
          } = callsheetdata.results[0];
          setCallsheet_id(callsheetdata.results[0].id);
          setPostData2({
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
          });
          setPostData({
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
            // production
            director_calltime,
            producer_calltime,
            pro_coordinator_calltime,
            travel_coordinator_calltime,
            upm_calltime,
            production_pa_calltime,
            script_supervisor_calltime,
            legal_calltime,
            set_medic_calltime,
            oth_production_pos_1_calltime,
            oth_production_pos_2_calltime,
            oth_production_pos_3_calltime,
            oth_production_pos_4_calltime,
            oth_production_pos_5_calltime,
            // art
            production_designer_calltime,
            art_director_calltime,
            art_assistant_calltime,
            set_decorator_calltime,
            set_dresser_calltime,
            lead_man_calltime,
            dresser_calltime,
            prop_master_calltime,
            ass_prop_master_calltime,
            prop_buyer_calltime,
            armorer_calltime,
            // cam
            dop_calltime,
            camera_operator_calltime,
            camera_ass_1_calltime,
            camera_ass_2_calltime,
            dit_calltime,
            steadicam_calltime,
            camera_pa_calltime,
            oth_camera_pos_1_calltime,
            oth_camera_pos_2_calltime,
            oth_camera_pos_3_calltime,
            oth_camera_pos_4_calltime,
            oth_camera_pos_5_calltime,
            // casting
            casting_director_calltime,
            extras_casting_calltime,
            ad_1_calltime,
            ad_2_calltime,
            ad_3_calltime,
            ad_4_calltime,
            ad_5_calltime,
            pro_assistant_1_calltime,
            pro_assistant_2_calltime,
            pro_assistant_3_calltime,
            pro_assistant_4_calltime,
            pro_assistant_5_calltime,
            // ele/Grip
            gaffer_calltime,
            best_boy_electric_calltime,
            electric_3_calltime,
            electric_4_calltime,
            keygrip_calltime,
            best_boy_grip_calltime,
            dolly_grip_calltime,
            swing_ge1_calltime,
            swing_ge2_calltime,
            swing_ge3_calltime,
            swing_ge4_calltime,
            swing_ge5_calltime,
            // locations
            location_mngr_calltime,
            location_security_calltime,
            location_ass_1_calltime,
            location_ass_2_calltime,
            location_ass_3_calltime,
            location_ass_4_calltime,
            // makeup
            key_hairmakeup_calltime,
            key_hairstylist_calltime,
            sfx_makeup_calltime,
            sfx_makeup_assistant_calltime,
            makeup_artist_1_calltime,
            makeup_artist_2_calltime,
            makeup_artist_3_calltime,
            makeup_artist_4_calltime,
            makeup_artist_5_calltime,
            // post/add-pos
            editor_calltime,
            fx_calltime,
            add_pos_1_calltime,
            add_pos_2_calltime,
            add_pos_3_calltime,
            add_pos_4_calltime,
            add_pos_5_calltime,
            add_pos_6_calltime,
            add_pos_7_calltime,
            add_pos_8_calltime,
            add_pos_9_calltime,
            add_pos_10_calltime,
            add_pos_11_calltime,
            add_pos_12_calltime,
            add_pos_13_calltime,
            add_pos_14_calltime,
            add_pos_15_calltime,
            add_pos_16_calltime,
            add_pos_17_calltime,
            add_pos_18_calltime,
            add_pos_19_calltime,
            add_pos_20_calltime,
            // script/cater
            writer_calltime,
            catering_co_1_calltime,
            catering_co_2_calltime,
            catering_co_3_calltime,
            craft_service_calltime,
            crafty_ass_calltime,
            // sound/transport
            sound_mixer_calltime,
            boom_operator_calltime,
            sound_assistant_1_calltime,
            sound_assistant_2_calltime,
            transport_captain_calltime,
            transport_manager_1_calltime,
            transport_manager_2_calltime,
            head_driver_calltime,
            car1_calltime,
            car2_calltime,
            car3_calltime,
            truck1_calltime,
            truck2_calltime,
            truck3_calltime,
            // stunts
            stunt_coordinator_calltime,
            stunts_1_calltime,
            stunts_2_calltime,
            stunts_3_calltime,
            stunts_4_calltime,
            stunts_5_calltime,
            // wardrobe
            costume_designer_calltime,
            ass_costume_designer_calltime,
            wardrobe_assistant_1_calltime,
            wardrobe_assistant_2_calltime,
            wardrobe_assistant_3_calltime,
            wardrobe_assistant_4_calltime,
            wardrobe_assistant_5_calltime,
          });
          setDayData({ results: [dayGet] });
          setScenes(scenesdata);
          setDataDay(dayGet.day);
          setDataDate(dayGet.date);
          setDays(daysData);
          setHasLoaded(true);
        } else {
          const [
            { data: dayGet },
            { data: scenesdata },
            { data: callsheetdata },
            { data: daysData },
          ] = await Promise.all([
            axiosInstance.get(
              `${localStorage.getItem("projectSlug")}/days/${id}/`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            axiosInstance.get(
              `${localStorage.getItem(
                "projectSlug"
              )}/schedule/scenes/?day_id=${id}${
                epi ? `&episode_ids=${epi}` : ""
              }`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            await axiosInstance.get(
              `${localStorage.getItem(
                "projectSlug"
              )}/callsheetsnew/?day_id=${id}${
                epi ? `&episode_ids=${epi}` : ""
              }`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            await axiosInstance.get(
            // if epi is present, add it to the query string
            `${localStorage.getItem(
              "projectSlug"
            )}/days/?${
              epi ? `&episode_ids=${epi}` : ""
            }`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem(
                  "accessToken"
                )}`,
              },
              withCredentials: true,
            }
          ),
          ]);
          const {
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
            director_calltime,
            producer_calltime,
            pro_coordinator_calltime,
            travel_coordinator_calltime,
            upm_calltime,
            production_pa_calltime,
            script_supervisor_calltime,
            legal_calltime,
            set_medic_calltime,
            oth_production_pos_1_calltime,
            oth_production_pos_2_calltime,
            oth_production_pos_3_calltime,
            oth_production_pos_4_calltime,
            oth_production_pos_5_calltime,
            production_designer_calltime,
            art_director_calltime,
            art_assistant_calltime,
            set_decorator_calltime,
            set_dresser_calltime,
            lead_man_calltime,
            dresser_calltime,
            prop_master_calltime,
            ass_prop_master_calltime,
            prop_buyer_calltime,
            armorer_calltime,
            dop_calltime,
            camera_operator_calltime,
            camera_ass_1_calltime,
            camera_ass_2_calltime,
            dit_calltime,
            steadicam_calltime,
            camera_pa_calltime,
            oth_camera_pos_1_calltime,
            oth_camera_pos_2_calltime,
            oth_camera_pos_3_calltime,
            oth_camera_pos_4_calltime,
            oth_camera_pos_5_calltime,
            casting_director_calltime,
            extras_casting_calltime,
            ad_1_calltime,
            ad_2_calltime,
            ad_3_calltime,
            ad_4_calltime,
            ad_5_calltime,
            pro_assistant_1_calltime,
            pro_assistant_2_calltime,
            pro_assistant_3_calltime,
            pro_assistant_4_calltime,
            pro_assistant_5_calltime,
            gaffer_calltime,
            best_boy_electric_calltime,
            electric_3_calltime,
            electric_4_calltime,
            keygrip_calltime,
            best_boy_grip_calltime,
            dolly_grip_calltime,
            swing_ge1_calltime,
            swing_ge2_calltime,
            swing_ge3_calltime,
            swing_ge4_calltime,
            swing_ge5_calltime,
            location_mngr_calltime,
            location_security_calltime,
            location_ass_1_calltime,
            location_ass_2_calltime,
            location_ass_3_calltime,
            location_ass_4_calltime,
            key_hairmakeup_calltime,
            key_hairstylist_calltime,
            sfx_makeup_calltime,
            sfx_makeup_assistant_calltime,
            makeup_artist_1_calltime,
            makeup_artist_2_calltime,
            makeup_artist_3_calltime,
            makeup_artist_4_calltime,
            makeup_artist_5_calltime,
            editor_calltime,
            fx_calltime,
            add_pos_1_calltime,
            add_pos_2_calltime,
            add_pos_3_calltime,
            add_pos_4_calltime,
            add_pos_5_calltime,
            add_pos_6_calltime,
            add_pos_7_calltime,
            add_pos_8_calltime,
            add_pos_9_calltime,
            add_pos_10_calltime,
            add_pos_11_calltime,
            add_pos_12_calltime,
            add_pos_13_calltime,
            add_pos_14_calltime,
            add_pos_15_calltime,
            add_pos_16_calltime,
            add_pos_17_calltime,
            add_pos_18_calltime,
            add_pos_19_calltime,
            add_pos_20_calltime,
            writer_calltime,
            catering_co_1_calltime,
            catering_co_2_calltime,
            catering_co_3_calltime,
            craft_service_calltime,
            crafty_ass_calltime,
            sound_mixer_calltime,
            boom_operator_calltime,
            sound_assistant_1_calltime,
            sound_assistant_2_calltime,
            transport_captain_calltime,
            transport_manager_1_calltime,
            transport_manager_2_calltime,
            head_driver_calltime,
            car1_calltime,
            car2_calltime,
            car3_calltime,
            truck1_calltime,
            truck2_calltime,
            truck3_calltime,
            stunt_coordinator_calltime,
            stunts_1_calltime,
            stunts_2_calltime,
            stunts_3_calltime,
            stunts_4_calltime,
            stunts_5_calltime,
            costume_designer_calltime,
            ass_costume_designer_calltime,
            wardrobe_assistant_1_calltime,
            wardrobe_assistant_2_calltime,
            wardrobe_assistant_3_calltime,
            wardrobe_assistant_4_calltime,
            wardrobe_assistant_5_calltime,
          } = callsheetdata.results[0];
          setCallsheet_id(callsheetdata.results[0].id);
          setPostData2({
            nearest_hospital,
            hospital_address_line_1,
            hospital_address_line_2,
            hospital_address_line_3,
          });
          setPostData({
            unit_call,
            talent_call,
            shoot_call,
            breakfast,
            lunch,
            wrap,
            basecamp_name,
            basecamp_address,
            basecamp_parking_n_notes,
            location_1_name,
            location_2_name,
            location_3_name,
            location_4_name,
            location_5_name,
            location_1_address,
            location_2_address,
            location_3_address,
            location_4_address,
            location_5_address,
            location_1_parking_n_notes,
            location_2_parking_n_notes,
            location_3_parking_n_notes,
            location_4_parking_n_notes,
            location_5_parking_n_notes,
            hospital_address_line_4,
            weather_location,
            important_info,
            transport_info,
            department_info,
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
            // production
            director_calltime,
            producer_calltime,
            pro_coordinator_calltime,
            travel_coordinator_calltime,
            upm_calltime,
            production_pa_calltime,
            script_supervisor_calltime,
            legal_calltime,
            set_medic_calltime,
            oth_production_pos_1_calltime,
            oth_production_pos_2_calltime,
            oth_production_pos_3_calltime,
            oth_production_pos_4_calltime,
            oth_production_pos_5_calltime,
            // art
            production_designer_calltime,
            art_director_calltime,
            art_assistant_calltime,
            set_decorator_calltime,
            set_dresser_calltime,
            lead_man_calltime,
            dresser_calltime,
            prop_master_calltime,
            ass_prop_master_calltime,
            prop_buyer_calltime,
            armorer_calltime,
            // cam
            dop_calltime,
            camera_operator_calltime,
            camera_ass_1_calltime,
            camera_ass_2_calltime,
            dit_calltime,
            steadicam_calltime,
            camera_pa_calltime,
            oth_camera_pos_1_calltime,
            oth_camera_pos_2_calltime,
            oth_camera_pos_3_calltime,
            oth_camera_pos_4_calltime,
            oth_camera_pos_5_calltime,
            // casting
            casting_director_calltime,
            extras_casting_calltime,
            ad_1_calltime,
            ad_2_calltime,
            ad_3_calltime,
            ad_4_calltime,
            ad_5_calltime,
            pro_assistant_1_calltime,
            pro_assistant_2_calltime,
            pro_assistant_3_calltime,
            pro_assistant_4_calltime,
            pro_assistant_5_calltime,
            // ele/Grip
            gaffer_calltime,
            best_boy_electric_calltime,
            electric_3_calltime,
            electric_4_calltime,
            keygrip_calltime,
            best_boy_grip_calltime,
            dolly_grip_calltime,
            swing_ge1_calltime,
            swing_ge2_calltime,
            swing_ge3_calltime,
            swing_ge4_calltime,
            swing_ge5_calltime,
            // locations
            location_mngr_calltime,
            location_security_calltime,
            location_ass_1_calltime,
            location_ass_2_calltime,
            location_ass_3_calltime,
            location_ass_4_calltime,
            // makeup
            key_hairmakeup_calltime,
            key_hairstylist_calltime,
            sfx_makeup_calltime,
            sfx_makeup_assistant_calltime,
            makeup_artist_1_calltime,
            makeup_artist_2_calltime,
            makeup_artist_3_calltime,
            makeup_artist_4_calltime,
            makeup_artist_5_calltime,
            // post/add-pos
            editor_calltime,
            fx_calltime,
            add_pos_1_calltime,
            add_pos_2_calltime,
            add_pos_3_calltime,
            add_pos_4_calltime,
            add_pos_5_calltime,
            add_pos_6_calltime,
            add_pos_7_calltime,
            add_pos_8_calltime,
            add_pos_9_calltime,
            add_pos_10_calltime,
            add_pos_11_calltime,
            add_pos_12_calltime,
            add_pos_13_calltime,
            add_pos_14_calltime,
            add_pos_15_calltime,
            add_pos_16_calltime,
            add_pos_17_calltime,
            add_pos_18_calltime,
            add_pos_19_calltime,
            add_pos_20_calltime,
            // script/cater
            writer_calltime,
            catering_co_1_calltime,
            catering_co_2_calltime,
            catering_co_3_calltime,
            craft_service_calltime,
            crafty_ass_calltime,
            // sound/transport
            sound_mixer_calltime,
            boom_operator_calltime,
            sound_assistant_1_calltime,
            sound_assistant_2_calltime,
            transport_captain_calltime,
            transport_manager_1_calltime,
            transport_manager_2_calltime,
            head_driver_calltime,
            car1_calltime,
            car2_calltime,
            car3_calltime,
            truck1_calltime,
            truck2_calltime,
            truck3_calltime,
            // stunts
            stunt_coordinator_calltime,
            stunts_1_calltime,
            stunts_2_calltime,
            stunts_3_calltime,
            stunts_4_calltime,
            stunts_5_calltime,
            // wardrobe
            costume_designer_calltime,
            ass_costume_designer_calltime,
            wardrobe_assistant_1_calltime,
            wardrobe_assistant_2_calltime,
            wardrobe_assistant_3_calltime,
            wardrobe_assistant_4_calltime,
            wardrobe_assistant_5_calltime,
          });
          setDayData({ results: [dayGet] });
          setScenes(scenesdata);
          setDataDay(dayGet.day);
          setDataDate(dayGet.date);
          setDays(daysData);
          // console.log(daysData)
          setHasLoaded(true);
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (host === CLIENT_PROGRAM_HOSTNAME) {
      handleMount();
    } else {
      if (localStorage.getItem("accessToken")) {
        handleMount();
      }
    }
    // eslint-disable-next-line
  }, [id]);


  // Fetch Characters Function
  const fetchCharacters = async () => {
    try {
      const host = window.location.hostname;
      let data;

      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axios.get("characters/");
        data = response.data;
        // console.log(data)
      } else {
        const response = await axios.get(
          `${localStorage.getItem("projectSlug")}/characters/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        data = response.data;
      }
      setCharactersList(data.results || []); // Ensure only results are stored
      // console.log(data)
    } catch (err) {
      console.error("Error fetching characters:", err);
    }
  };

  useEffect(() => {
    fetchCharacters();
  }, []);

  // Hospitals request
  const fetchHospitals = async () => {
        try {
          if (host === CLIENT_PROGRAM_HOSTNAME) {
            const { data } = await axiosReq.get(`/masters/hospitals/`)
            setHospitals(data)
          } else {
            const response = await axiosInstance.get(
              `${localStorage.getItem(
                "projectSlug"
                )}/masters/hospitals/`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                withCredentials: true,
              }
            )
            if (response?.success === false) {
              throw response.error;
            }
            const { data } = response;
            // console.log(data)
            setHospitals(data)
            setHasLoaded(true)
          }
        } catch (err) {
          console.log(err)
          const backendError =
            err?.response?.data?.error ||
            err?.response?.data?.detail ||
            "Failed to load hospitals.";
          toast.error(backendError);
          if (err.response?.status !== 401) {
            setErrors(err.response?.data || { detail: [backendError] })
            setHasLoaded(true)
          }
        }
      }

  useEffect(() => {
    fetchHospitals();
    // eslint-disable-next-line
  }, []);

  const setData = (hospital) => {
    /* Function to set hospital values automatically
         when a hospital is selected from the dropdown */
    const hosname = hospital.name || "";
    const hosadd1 = hospital.address_line_1 || "";
    const hosadd2 = hospital.address_line_2 || "";
    const hosadd3 = hospital.address_line_3 || "";

    setPostData2({
      nearest_hospital: hosname,
      hospital_address_line_1: hosadd1,
      hospital_address_line_2: hosadd2,
      hospital_address_line_3: hosadd3,
    });
  };

  /* Function to set all crew call times to the unit call time */
    const setUnitCall = () => {
    setPostData({
      ...postData,
      // production 
    director_calltime: unit_call,
    producer_calltime: unit_call,
    pro_coordinator_calltime: unit_call,
    travel_coordinator_calltime: unit_call,
    upm_calltime: unit_call,
    production_pa_calltime: unit_call,
    script_supervisor_calltime: unit_call,
    legal_calltime: unit_call,
    set_medic_calltime: unit_call,
    oth_production_pos_1_calltime: unit_call,
    oth_production_pos_2_calltime: unit_call,
    oth_production_pos_3_calltime: unit_call,
    oth_production_pos_4_calltime: unit_call,
    oth_production_pos_5_calltime: unit_call,
    // art
    production_designer_calltime: unit_call,
    art_director_calltime: unit_call,
    art_assistant_calltime: unit_call,
    set_decorator_calltime: unit_call,
    set_dresser_calltime: unit_call,
    lead_man_calltime: unit_call,
    dresser_calltime: unit_call,
    prop_master_calltime: unit_call,
    ass_prop_master_calltime: unit_call,
    prop_buyer_calltime: unit_call,
    armorer_calltime: unit_call,
    // cam
    dop_calltime: unit_call,
    camera_operator_calltime: unit_call,
    camera_ass_1_calltime: unit_call,
    camera_ass_2_calltime: unit_call,
    dit_calltime: unit_call,
    steadicam_calltime: unit_call,
    camera_pa_calltime: unit_call,
    oth_camera_pos_1_calltime: unit_call,
    oth_camera_pos_2_calltime: unit_call,
    oth_camera_pos_3_calltime: unit_call,
    oth_camera_pos_4_calltime: unit_call,
    oth_camera_pos_5_calltime: unit_call,
    // casting
    casting_director_calltime: unit_call,
    extras_casting_calltime: unit_call,
    ad_1_calltime: unit_call,
    ad_2_calltime: unit_call,
    ad_3_calltime: unit_call,
    ad_4_calltime: unit_call,
    ad_5_calltime: unit_call,
    pro_assistant_1_calltime: unit_call,
    pro_assistant_2_calltime: unit_call,
    pro_assistant_3_calltime: unit_call,
    pro_assistant_4_calltime: unit_call,
    pro_assistant_5_calltime: unit_call,
    // elegrip
    gaffer_calltime: unit_call,
    best_boy_electric_calltime: unit_call,
    electric_3_calltime: unit_call,
    electric_4_calltime: unit_call,
    keygrip_calltime: unit_call,
    best_boy_grip_calltime: unit_call,
    dolly_grip_calltime: unit_call,
    swing_ge1_calltime: unit_call,
    swing_ge2_calltime: unit_call,
    swing_ge3_calltime: unit_call,
    swing_ge4_calltime: unit_call,
    swing_ge5_calltime: unit_call,
    // loc
    location_mngr_calltime: unit_call,
    location_ass_1_calltime: unit_call,
    location_ass_2_calltime: unit_call,
    location_ass_3_calltime: unit_call,
    location_ass_4_calltime: unit_call,
    location_security_calltime: unit_call,
    // mak
    key_hairmakeup_calltime: unit_call,
    key_hairstylist_calltime: unit_call,
    sfx_makeup_calltime: unit_call,
    sfx_makeup_assistant_calltime: unit_call,
    makeup_artist_1_calltime: unit_call,
    makeup_artist_2_calltime: unit_call,
    makeup_artist_3_calltime: unit_call,
    makeup_artist_4_calltime: unit_call,
    makeup_artist_5_calltime: unit_call,
    // post/add-pos
    editor_calltime: unit_call,
    fx_calltime: unit_call,
    add_pos_1_calltime: unit_call,
    add_pos_2_calltime: unit_call,
    add_pos_3_calltime: unit_call,
    add_pos_4_calltime: unit_call,
    add_pos_5_calltime: unit_call,
    add_pos_6_calltime: unit_call,
    add_pos_7_calltime: unit_call,
    add_pos_8_calltime: unit_call,
    add_pos_9_calltime: unit_call,
    add_pos_10_calltime: unit_call,
    add_pos_11_calltime: unit_call,
    add_pos_12_calltime: unit_call,
    add_pos_13_calltime: unit_call,
    add_pos_14_calltime: unit_call,
    add_pos_15_calltime: unit_call,
    add_pos_16_calltime: unit_call,
    add_pos_17_calltime: unit_call,
    add_pos_18_calltime: unit_call,
    add_pos_19_calltime: unit_call,
    add_pos_20_calltime: unit_call,
    // script/cater
    writer_calltime: unit_call,
    catering_co_1_calltime: unit_call,
    catering_co_2_calltime: unit_call,
    catering_co_3_calltime: unit_call,
    craft_service_calltime: unit_call,
    crafty_ass_calltime: unit_call,
    // sound/transport
    sound_mixer_calltime: unit_call,
    boom_operator_calltime: unit_call,
    sound_assistant_1_calltime: unit_call,
    sound_assistant_2_calltime: unit_call,
    transport_captain_calltime: unit_call,
    transport_manager_1_calltime: unit_call,
    transport_manager_2_calltime: unit_call,
    head_driver_calltime: unit_call,
    car1_calltime: unit_call,
    car2_calltime: unit_call,
    car3_calltime: unit_call,
    truck1_calltime: unit_call,
    truck2_calltime: unit_call,
    truck3_calltime: unit_call,
    // stunts
    stunt_coordinator_calltime: unit_call,
    stunts_1_calltime: unit_call,
    stunts_2_calltime: unit_call,
    stunts_3_calltime: unit_call,
    stunts_4_calltime: unit_call,
    stunts_5_calltime: unit_call,
    // wardrobe
    costume_designer_calltime: unit_call,
    ass_costume_designer_calltime: unit_call,
    wardrobe_assistant_1_calltime: unit_call,
    wardrobe_assistant_2_calltime: unit_call,
    wardrobe_assistant_3_calltime: unit_call,
    wardrobe_assistant_4_calltime: unit_call,
    wardrobe_assistant_5_calltime: unit_call,
    });
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    // info
    formData.append("day_id", id);
    if (epi !== null) {
      formData.append("episode", epi);
    }
    formData.append("day", dataDay);
    formData.append("date", dataDate);
    formData.append("unit_call", unit_call);
    formData.append("talent_call", talent_call);
    formData.append("shoot_call", shoot_call);
    formData.append("breakfast", breakfast);
    formData.append("lunch", lunch);
    formData.append("wrap", wrap);
    formData.append("basecamp_name", basecamp_name);
    formData.append("basecamp_address", basecamp_address);
    formData.append("basecamp_parking_n_notes", basecamp_parking_n_notes);
    formData.append("location_1_name", location_1_name);
    formData.append("location_2_name", location_2_name);
    formData.append("location_3_name", location_3_name);
    formData.append("location_4_name", location_4_name);
    formData.append("location_5_name", location_5_name);
    formData.append("location_1_address", location_1_address);
    formData.append("location_2_address", location_2_address);
    formData.append("location_3_address", location_3_address);
    formData.append("location_4_address", location_4_address);
    formData.append("location_5_address", location_5_address);
    formData.append("location_1_parking_n_notes", location_1_parking_n_notes);
    formData.append("location_2_parking_n_notes", location_2_parking_n_notes);
    formData.append("location_3_parking_n_notes", location_3_parking_n_notes);
    formData.append("location_4_parking_n_notes", location_4_parking_n_notes);
    formData.append("location_5_parking_n_notes", location_5_parking_n_notes);
    formData.append("nearest_hospital", nearest_hospital);
    formData.append("hospital_address_line_1", hospital_address_line_1);
    formData.append("hospital_address_line_2", hospital_address_line_2);
    formData.append("hospital_address_line_3", hospital_address_line_3);
    formData.append("hospital_address_line_4", hospital_address_line_4);
    formData.append("weather_location", weather_location);
    formData.append("important_info", important_info);
    formData.append("transport_info", transport_info);
    formData.append("department_info", department_info);
    // production
    formData.append("director_calltime", director_calltime);
    formData.append("producer_calltime", producer_calltime);
    formData.append("pro_coordinator_calltime", pro_coordinator_calltime);
    formData.append("travel_coordinator_calltime", travel_coordinator_calltime);
    formData.append("upm_calltime", upm_calltime);
    formData.append("production_pa_calltime", production_pa_calltime);
    formData.append("script_supervisor_calltime", script_supervisor_calltime);
    formData.append("legal_calltime", legal_calltime);
    formData.append("set_medic_calltime", set_medic_calltime);
    formData.append(
      "oth_production_pos_1_calltime",
      oth_production_pos_1_calltime
    );
    formData.append(
      "oth_production_pos_2_calltime",
      oth_production_pos_2_calltime
    );
    formData.append(
      "oth_production_pos_3_calltime",
      oth_production_pos_3_calltime
    );
    formData.append(
      "oth_production_pos_4_calltime",
      oth_production_pos_4_calltime
    );
    formData.append(
      "oth_production_pos_5_calltime",
      oth_production_pos_5_calltime
    );
    // art
    formData.append(
      "production_designer_calltime",
      production_designer_calltime
    );
    formData.append("art_director_calltime", art_director_calltime);
    formData.append("art_assistant_calltime", art_assistant_calltime);
    formData.append("set_decorator_calltime", set_decorator_calltime);
    formData.append("set_dresser_calltime", set_dresser_calltime);
    formData.append("lead_man_calltime", lead_man_calltime);
    formData.append("dresser_calltime", dresser_calltime);
    formData.append("prop_master_calltime", prop_master_calltime);
    formData.append("ass_prop_master_calltime", ass_prop_master_calltime);
    formData.append("prop_buyer_calltime", prop_buyer_calltime);
    formData.append("armorer_calltime", armorer_calltime);
    // camera
    formData.append("dop_calltime", dop_calltime);
    formData.append("camera_operator_calltime", camera_operator_calltime);
    formData.append("camera_ass_1_calltime", camera_ass_1_calltime);
    formData.append("camera_ass_2_calltime", camera_ass_2_calltime);
    formData.append("dit_calltime", dit_calltime);
    formData.append("steadicam_calltime", steadicam_calltime);
    formData.append("camera_pa_calltime", camera_pa_calltime);
    formData.append("oth_camera_pos_1_calltime", oth_camera_pos_1_calltime);
    formData.append("oth_camera_pos_2_calltime", oth_camera_pos_2_calltime);
    formData.append("oth_camera_pos_3_calltime", oth_camera_pos_3_calltime);
    formData.append("oth_camera_pos_4_calltime", oth_camera_pos_4_calltime);
    formData.append("oth_camera_pos_5_calltime", oth_camera_pos_5_calltime);
    // casting
    formData.append("casting_director_calltime", casting_director_calltime);
    formData.append("extras_casting_calltime", extras_casting_calltime);
    formData.append("ad_1_calltime", ad_1_calltime);
    formData.append("ad_2_calltime", ad_2_calltime);
    formData.append("ad_3_calltime", ad_3_calltime);
    formData.append("ad_4_calltime", ad_4_calltime);
    formData.append("ad_5_calltime", ad_5_calltime);
    formData.append("pro_assistant_1_calltime", pro_assistant_1_calltime);
    formData.append("pro_assistant_2_calltime", pro_assistant_2_calltime);
    formData.append("pro_assistant_3_calltime", pro_assistant_3_calltime);
    formData.append("pro_assistant_4_calltime", pro_assistant_4_calltime);
    formData.append("pro_assistant_5_calltime", pro_assistant_5_calltime);
    // ElectricGrip
    formData.append("gaffer_calltime", gaffer_calltime);
    formData.append("best_boy_electric_calltime", best_boy_electric_calltime);
    formData.append("electric_3_calltime", electric_3_calltime);
    formData.append("electric_4_calltime", electric_4_calltime);
    formData.append("keygrip_calltime", keygrip_calltime);
    formData.append("best_boy_grip_calltime", best_boy_grip_calltime);
    formData.append("dolly_grip_calltime", dolly_grip_calltime);
    formData.append("swing_ge1_calltime", swing_ge1_calltime);
    formData.append("swing_ge2_calltime", swing_ge2_calltime);
    formData.append("swing_ge3_calltime", swing_ge3_calltime);
    formData.append("swing_ge4_calltime", swing_ge4_calltime);
    formData.append("swing_ge5_calltime", swing_ge5_calltime);
    // loc
    formData.append("location_mngr_calltime", location_mngr_calltime);
    formData.append("location_security_calltime", location_security_calltime);
    formData.append("location_ass_1_calltime", location_ass_1_calltime);
    formData.append("location_ass_2_calltime", location_ass_2_calltime);
    formData.append("location_ass_3_calltime", location_ass_3_calltime);
    formData.append("location_ass_4_calltime", location_ass_4_calltime);
    // makeup
    formData.append("key_hairmakeup_calltime", key_hairmakeup_calltime);
    formData.append("key_hairstylist_calltime", key_hairstylist_calltime);
    formData.append("sfx_makeup_calltime", sfx_makeup_calltime);
    formData.append(
      "sfx_makeup_assistant_calltime",
      sfx_makeup_assistant_calltime
    );
    formData.append("makeup_artist_1_calltime", makeup_artist_1_calltime);
    formData.append("makeup_artist_2_calltime", makeup_artist_2_calltime);
    formData.append("makeup_artist_3_calltime", makeup_artist_3_calltime);
    formData.append("makeup_artist_4_calltime", makeup_artist_4_calltime);
    formData.append("makeup_artist_5_calltime", makeup_artist_5_calltime);
    // post/add-pos
    formData.append("editor_calltime", editor_calltime);
    formData.append("fx_calltime", fx_calltime);
    formData.append("add_pos_1_calltime", add_pos_1_calltime);
    formData.append("add_pos_2_calltime", add_pos_2_calltime);
    formData.append("add_pos_3_calltime", add_pos_3_calltime);
    formData.append("add_pos_4_calltime", add_pos_4_calltime);
    formData.append("add_pos_5_calltime", add_pos_5_calltime);
    formData.append("add_pos_6_calltime", add_pos_6_calltime);
    formData.append("add_pos_7_calltime", add_pos_7_calltime);
    formData.append("add_pos_8_calltime", add_pos_8_calltime);
    formData.append("add_pos_9_calltime", add_pos_9_calltime);
    formData.append("add_pos_10_calltime", add_pos_10_calltime);
    // add 2
    formData.append("add_pos_11_calltime", add_pos_11_calltime);
    formData.append("add_pos_12_calltime", add_pos_12_calltime);
    formData.append("add_pos_13_calltime", add_pos_13_calltime);
    formData.append("add_pos_14_calltime", add_pos_14_calltime);
    formData.append("add_pos_15_calltime", add_pos_15_calltime);
    formData.append("add_pos_16_calltime", add_pos_16_calltime);
    formData.append("add_pos_17_calltime", add_pos_17_calltime);
    formData.append("add_pos_18_calltime", add_pos_18_calltime);
    formData.append("add_pos_19_calltime", add_pos_19_calltime);
    formData.append("add_pos_20_calltime", add_pos_20_calltime);
    // script/cater
    formData.append("writer_calltime", writer_calltime);
    formData.append("catering_co_1_calltime", catering_co_1_calltime);
    formData.append("catering_co_2_calltime", catering_co_2_calltime);
    formData.append("catering_co_3_calltime", catering_co_3_calltime);
    formData.append("craft_service_calltime", craft_service_calltime);
    formData.append("crafty_ass_calltime", crafty_ass_calltime);
    // sound/transport
    formData.append("sound_mixer_calltime", sound_mixer_calltime);
    formData.append("boom_operator_calltime", boom_operator_calltime);
    formData.append("sound_assistant_1_calltime", sound_assistant_1_calltime);
    formData.append("sound_assistant_2_calltime", sound_assistant_2_calltime);
    formData.append("transport_captain_calltime", transport_captain_calltime);
    formData.append(
      "transport_manager_1_calltime",
      transport_manager_1_calltime
    );
    formData.append(
      "transport_manager_2_calltime",
      transport_manager_2_calltime
    );
    formData.append("head_driver_calltime", head_driver_calltime);
    formData.append("car1_calltime", car1_calltime);
    formData.append("car2_calltime", car2_calltime);
    formData.append("car3_calltime", car3_calltime);
    formData.append("truck1_calltime", truck1_calltime);
    formData.append("truck2_calltime", truck2_calltime);
    formData.append("truck3_calltime", truck3_calltime);
    // stunts
    formData.append("stunt_coordinator_calltime", stunt_coordinator_calltime);
    formData.append("stunts_1_calltime", stunts_1_calltime);
    formData.append("stunts_2_calltime", stunts_2_calltime);
    formData.append("stunts_3_calltime", stunts_3_calltime);
    formData.append("stunts_4_calltime", stunts_4_calltime);
    formData.append("stunts_5_calltime", stunts_5_calltime);
    // wardrobe
    formData.append("costume_designer_calltime", costume_designer_calltime);
    formData.append(
      "ass_costume_designer_calltime",
      ass_costume_designer_calltime
    );
    formData.append(
      "wardrobe_assistant_1_calltime",
      wardrobe_assistant_1_calltime
    );
    formData.append(
      "wardrobe_assistant_2_calltime",
      wardrobe_assistant_2_calltime
    );
    formData.append(
      "wardrobe_assistant_3_calltime",
      wardrobe_assistant_3_calltime
    );
    formData.append(
      "wardrobe_assistant_4_calltime",
      wardrobe_assistant_4_calltime
    );
    formData.append(
      "wardrobe_assistant_5_calltime",
      wardrobe_assistant_5_calltime
    );
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.put(
          `/callsheetsnew/${callsheet_id}/`,
          formData
        ); 
        toast.success(`Callsheet Updated`);
        history.goBack();
      } else {
        await axiosInstance.put(
          `${localStorage.getItem(
            "projectSlug"
          )}/callsheetsnew/${callsheet_id}/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        ); 
        toast.success(`Callsheet Updated Successfully!`);
        history.goBack();
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const infoFields = (
    <div className={`pb-3 px-3 text-center ${styles.White }`}>
      {/* TIMES   */}
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      TIMES
      </h5>
      </Col>
      </Row>
      <div>
      {/* Unit call - Talent call Shoot call */}
      <Row>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="unit_call" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Unit Call</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="unit_call"
                value={unit_call}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.unit_call?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="talent_call" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Talent Call</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="talent_call"
                value={talent_call}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.talent_call?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="shoot_call" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Shoot Call</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="shoot_call"
                value={shoot_call}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.shoot_call?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <hr className="mt-1 mb-0"/>
      {/* breakfast - lunch - wrap */}
      <Row>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="breakfast" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Breakfast</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="breakfast"
                value={breakfast}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.breakfast?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="lunch" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Lunch</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="lunch"
                value={lunch}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.lunch?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="wrap" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Est. Wrap</Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="wrap"
                value={wrap}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.wrap?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      <hr/>
      {/* Wea INFO */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      WEATHER
      </h5>
      </Col>
      </Row>
      {/* weather using location_2_name */}
      <Row className="mt-2">
      <Col className="d-flex justify-content-center"
        xs={{span: 10, offset: 1}} md={{span: 8, offset: 2}}>
        <Form.Group controlId="location_2_name" className={`${styles.Width95} `}  >
        <Form.Label className={`${styles.BoldScene}`} >Weather
            </Form.Label>
            <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_2_name"
              value={location_2_name}
              onChange={handleChange}
                />
        </Form.Group>
        {errors?.location_2_name?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      </Row>
      {/* rise using location_3_name - set using location_4_name */}
      <Row className="my-3">
            <Col className="d-flex justify-content-center" xs={6} >
                <Form.Group controlId="location_3_name" className={`${styles.Width95} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Sunrise
                    </Form.Label>
                    <Form.Control 
                      className={`${styles.Input}`}
                      type="text"
                      name="location_3_name"
                      value={location_3_name}
                      onChange={handleChange}
                        />
                </Form.Group>
                {errors?.location_3_name?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
            </Col>
            <Col className="d-flex justify-content-center" xs={6} >
              <Form.Group controlId="location_4_name" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Sunset
                  </Form.Label>
                  <Form.Control 
                    className={`${styles.Input}`}
                    type="text"
                    name="location_4_name"
                    value={location_4_name}
                    onChange={handleChange}
                      />
              </Form.Group>
              {errors?.location_4_name?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
            </Col>
      </Row>
      </div> 
      <hr/>
      {/* hos INFO */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center ${styles.SubTitleC }`} >
      NEAREST HOSPITAL
      </h5>
      </Col>
      </Row>
      <p className={`${styles.SmallSize} text-center py-2`}
      style={{fontStyle: 'italic'}}>Select the Nearest Hospital 
        from the Dropdown. Add Hospitals to the Dropdown on the Callsheets page.
      </p>
      {/* hospitals */}
      <Row className="d-flex align-items-center">
      <Col md={6} className=" p-2">
      <Dropdown className={`${styles.Add }`}>
          <Dropdown.Toggle variant="info" id="dropdown-basic" size="sm">
            HOSPITALS
          </Dropdown.Toggle>
          <Dropdown.Menu className={`pt-1 pl-2 ${styles.DropButt}`}>
          {hospitals.results.length && (
                hospitals.results.map((hospital) => (
                  <Dropdown.Item onClick={() => setData(hospital) } 
                  key={hospital.id} >{hospital.name}</Dropdown.Item>
                ) )) }
          </Dropdown.Menu>
      </Dropdown> 
      </Col>
      <Col xs={{span: 8, offset: 2}} md={{span: 3, offset: 1}} className="p-2">
        <p className={`mt-3`}>
        {nearest_hospital}
        </p>
        <hr className={`mt-0 mb-0 ${styles.HRGold2 }`}/>
        </Col>
      </Row>
      </div> 
      <hr/>
      {/* BASECAMP */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      BASECAMP
      </h5>
      </Col>
      </Row>
      <Row className="mb-2">
      <Col xs={12} md={{span: 6, offset: 3}} className="d-flex justify-content-center pt-2 p-md-2">
      <Form.Group controlId="basecamp_name" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Basecamp Name</Form.Label>
          <Form.Control 
            className={`${styles.Input}`}
            type="text"
            name="basecamp_name"
            value={basecamp_name}
            onChange={handleChange}
              />
      </Form.Group>
      {errors?.basecamp_name?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      <Row className="mb-2 mt-3">
      <Col xs={12} md={6}  className="d-flex justify-content-center pt-2 p-md-2">
      <Form.Group controlId="basecamp_address" className={`${styles.Width95} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Basecamp Address</Form.Label>
          <Form.Control 
            className={`${styles.InputScene}`}
            type="text"
            as="textarea"
            rows={1}
            name="basecamp_address"
            value={basecamp_address}
            onChange={handleChange}
              />
      </Form.Group>
      {errors?.basecamp_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      <Col xs={12} md={6}  className="d-flex justify-content-center pt-2 p-md-2">
      <Form.Group controlId="basecamp_parking_n_notes" className={`${styles.Width95} `}  >
          <Form.Label className={`d-none d-md-block ${styles.BoldScene}`}>Basecamp Parking and Notes</Form.Label>
          <Form.Label className={`d-md-none ${styles.BoldScene}`}>Basecamp Notes</Form.Label>
          <Form.Control 
            className={`${styles.InputScene}`}
            as="textarea"
            rows={1}
            type="text"
            name="basecamp_parking_n_notes"
            value={basecamp_parking_n_notes}
            onChange={handleChange}
              />
      </Form.Group>
      {errors?.basecamp_parking_n_notes?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      </div>
      <hr/>
      {/* DEPARTMENT & IMPORTANT INFO */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      INFORMATION
      </h5>
      </Col>
      </Row> 
      {/* department info */}
      <Row className="mt-2">
      <Col md={{span: 10, offset: 1}} className="d-flex justify-content-center p-0 p-md-2 ">
          <Form.Group controlId="department_info" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Shoot Info</Form.Label>
              <Form.Control 
                className={`${styles.InputScene}`}
                as="textarea"
                rows={1}
                type="text"
                name="department_info"
                value={department_info}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.department_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      </Row>
      {/* impor - transport info */}
      <Row className="mt-2">
      <Col md={6} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="important_info" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`}>Important Info</Form.Label>
              <Form.Control 
                className={`${styles.InputScene}`}
                as="textarea"
                rows={1}
                type="text"
                name="important_info"
                value={important_info}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.important_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col md={6} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="transport_info" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Transport Info</Form.Label>
              <Form.Control 
                className={`${styles.InputScene}`}
                type="text"
                as="textarea"
                rows={1}
                name="transport_info"
                value={transport_info}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.transport_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      </Row>
      </div>
      <hr/>
      {/* WALKIE CHANNELS */}
      {/* <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
      WALKIES CHANNELS
      </h5>
      </Col>
      </Row> 
      <Row className="pt-2">
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_production" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Production</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_production"
              value={walkie_channel_production}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_production?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_open" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Open</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_open"
              value={walkie_channel_open}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_open?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_transportation" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Transport</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_transportation"
              value={walkie_channel_transportation}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_transportation?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_art_dept" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Art Dept</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_art_dept"
              value={walkie_channel_art_dept}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_art_dept?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      <hr className="mb-1"/>
      <Row>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_rollover" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Rollover</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_rollover"
              value={walkie_channel_rollover}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_rollover?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_camera" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Camera</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_camera"
              value={walkie_channel_camera}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_camera?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_electric" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Electric</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_electric"
              value={walkie_channel_electric}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_electric?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="walkie_channel_grip" className={`${styles.Width} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Grip</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="walkie_channel_grip"
              value={walkie_channel_grip}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.walkie_channel_grip?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div> 
      <hr/> */}
      <Row>
      <Col md={6} >
      {/* advanced sched using hospital_address_line_4 */}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
      <h5 className={`text-center ${styles.SubTitleC }`} >
      ADVANCED SCHEDULE
      </h5>
      </Col>
      </Row> 
      <p className={`${styles.SmallSize } text-center pt-2`}
      style={{fontStyle: 'italic'}}>Use the Shoot Days Dropdown to select the Advanced Schedule Day.
      </p>
      <Row >
      <Col md={{span: 6, offset: 3}} className="d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="hospital_address_line_4" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`} >Select Shoot Day</Form.Label>
              <Form.Control as="select"
                name="hospital_address_line_4"
                className={styles.Input}
                value={hospital_address_line_4}
                onChange={handleChange}
                aria-label="location select">
                  <option  ></option>
                {days.results?.length && (
                    days.results.map((day) => (
                      <option key={day.id} value={day.id} >{`Shoot Day ${day.day}`}</option>
                    ) )) }
              </Form.Control>
          </Form.Group>
          {errors?.hospital_address_line_4?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      </Row> 
      </div>
      <hr/>
      </Col>
      <Col md={6} >
      {/* COUNTRY INFO using location_5_name*/}
      <div className="mt-5">
      <Row>
      <Col md={{span: 10, offset: 1}} >
       <h5 className={`text-center ${styles.SubTitleC }`} >
      OTHER COUNTRY UNITS
      </h5>
      </Col>
      </Row> 
      <p className={`${styles.SmallSize } my-2`} style={{fontStyle: 'italic'}}>
        Enter the relevant city or country name here <span className={`${styles.Red}`}>ONLY</span> if the Shoot is in a 
        different country to the main Shoot
        </p>
      {/* Different Country location_5_name */}
      <Row className="my-2">
        <Col className="d-flex justify-content-center" xs={{span: 6, offset: 3}} >
          <Form.Group controlId="location_5_name" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`} >City/Country Name
              </Form.Label>
              <Form.Control 
                className={`${styles.Input}`}
                type="text"
                name="location_5_name"
                value={location_5_name}
                onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_5_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      </div>  
      <hr/>
      </Col>
      </Row>
    </div>
  )

  const buttons = (
    <div className={`text-center py-4 mb-3 mt-4 ${styles.White }`} >    
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`ml-3 ${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3 `} type="submit">
        Submit
      </Button>
    </div>
  );

  return (
    <div>
      {hasLoaded ? (
        <>
          <TopBox
            work="Callsheet Add/Edit"
            title3={`Day ${dataDay} - ${dataDate} `}
          />
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} mt-1`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
          <Button
            className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowInfo((showInfo) => !showInfo)}
          >
            INFO
          </Button>
          {!showInfo ? "" : <InformationEdit />}
          <div className="text-center d-none d-md-block "></div>
          {/* cast bg */}
          <div className= {`mb-4 ${styles.White }`}>
          <h5 className={`text-center py-1 mt-2 pr-5 mr-2 ${styles.SubTitle }`} >
            <span className="float-left pl-2" >Section 1</span>
          CAST & BG/STAND-INS FORMS</h5> 
          <Row className="text-center">
          <Col xs={12} md={{span: 8, offset: 2 }} >
          <p className={`${styles.SmallSize } pt-2`} style={{fontStyle: 'italic'}}>
          Add/Edit Cast and BG/Stand-ins Calls here. These forms are seperate from the 
          Main Callsheet Form below.
          </p>
          </Col>
          </Row>
          {/* schedule button */}
          <Row className='text-center'>
          <Col  >
          <Button
            className={`mt-3 ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowSchedule(showSchedule => !showSchedule)} >View Schedule
          </Button>
          </Col>
          </Row>
          {/* cast buttons */}
          <Row className='text-center'>
          {/* cast */}
          <Col className='text-center mx-0 px-0' xs={{span: 6, order: 1}} sm={{span: 4, order: 1}}>
          <Button
            className={`mt-3 px-4 px-md-5 ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowAddCast(showAddCast => !showAddCast)} >Add Cast
          </Button>
          </Col>
          {/* Schedule and Cast Forms */}
          <Col xs={{span: 12, order: 12}} sm={{span: 4, order: 2}} 
          className='text-center mx-0 px-0'  >
          <Button
            className={`my-3 px-3 ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowSideBySide(showSideBySide => !showSideBySide)} >
              Schedule and Talent Forms
          </Button>
          </Col>
          {/* BG */}
          <Col className='text-center mx-0 px-0' xs={{span: 6, order: 2}} sm={{span: 4, order: 3}}  >
          <Button
            className={`my-3 px-4 px-md-5  ${btnStyles.Button} ${btnStyles.Bright}`}
            onClick={() => setShowAddBg(showAddBg => !showAddBg)} >
              Add BG
          </Button>
          </Col>
          </Row>
          {/* schedule */}
          <div className="mt-3">
          {!showSchedule ? (
          ""
          ) : (
          <>
          <SchedulePage
          setShow={setShowSchedule}
          scenes={scenes} />
          </>
          ) }
          </div>
          {/* add cast */}
          <div>
          {!showAddCast ? (
          ""
          ) : (
          <AddCast id={id} setShow={setShowAddCast} 
          charactersList={charactersList}
          dataDay={dataDay} dataDate={dataDate} />
          ) }
          </div> 
          {/* add bg */}
          <div>
          {!showAddBg ? (
          ""
          ) : (
          <AddBackGround 
          id={id} 
          setShow={setShowAddBg} 
          dataDay={dataDay} dataDate={dataDate} />
          ) }
          </div> 
          {/* SideBySide */}
          {!showSideBySide ? (
          ""
          ) : (  
            <div>                    
          <Row className="mx-0">
            <Col className="px-1" lg={6}>
            <SchedulePage
            showSideBySide={showSideBySide}
            setShow={setShowSideBySide}
            scenes={scenes}  />
            </Col>
            <Col lg={6} className="pt-3">
            <div>
            <AddCast 
            id={id} 
            setShow={setShowSideBySide} 
            charactersList={charactersList}
            dataDay={dataDay} dataDate={dataDate} />
              </div>
              <div>
            <AddBackGround 
            setShow={setShowSideBySide} 
            id={id} 
            dataDay={dataDay} dataDate={dataDate} />
              </div>
            </Col>
          </Row>  
          </div>           
          ) }
          </div>
          {/* big break */}
          <Row className='my-5 pb-5'>
          <Col xs={2} ></Col>
          <Col xs={8}>
          <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
          <hr className={`${styles.BreakBlack} my-0`}/>
          </Col>
          </Row>
          <h5 className={`text-center mt-3 mb-0 py-2 mr-3 pr-5 ${styles.SubTitle }`} >
            <span className="float-left pl-2" >Section 2</span>
          MAIN CALLSHEET FORM</h5> 
          <Row className={`${styles.White }`}>
          <Col md={{span: 8, offset: 2}} >
          <p className={`${styles.SmallSize } mt-2 mb-2 text-center`} style={{fontStyle: 'italic'}}>
          Add/Edit Callsheet Times, Weather, Hospital, Basecamp, Info, Walkies, Adv Schedule and Crew Calls here.
          </p>
          </Col>
          </Row>
          {/* callsheet info */}
          <Form className= {`mb-1 ${styles.White }`} onSubmit={handleSubmit}>
          {infoFields}
          {/* crew */}
          <Row className="mt-5">
          <Col md={{span: 10, offset: 1}} className="text-center">
          <h5 className={`text-center mb-3 ${styles.SubTitleC }`} >
          CREW CALLTIMES
          </h5>
          </Col>
          </Row>
          {/* info buttons */}
          <Row>
          <Col xs={6} >
          <Button
              className={`px-0 px-md-3 py-0 mt-2 ${btnStyles.Order} ${btnStyles.Button}`}
              onClick={() => setShowInfoCrew(showInfoCrew => !showInfoCrew)} >Unit Call Info
          </Button>
          </Col>
          <Col xs={6} >
          <Button
              className={`float-right py-0 mt-2 ${btnStyles.Order} ${btnStyles.Button}`}
              onClick={() => setShowImportantCrew(showImportantCrew => !showImportantCrew)} >Important
          </Button>
          </Col>
          </Row>
          {/* unit call button */}
          <div>
          <Row>
          <Col className="text-center" >
          <Button
              className={`py-0 my-2 px-5 ${btnStyles.Shed} ${btnStyles.Button}`}
              onClick={setUnitCall} >SET UNIT CALL
          </Button>
          </Col>
          </Row>
          </div>
          {/* info components */}
          <div>
          <Row>
            <Col >
            <div className="mt-3">
            {!showImportantCrew ? (
              ""
                  ) : (
                    <ImportantCrewCalls  /> 
                    ) } 
            </div>
            </Col>
          </Row>
          <Row>
            <Col >
            <div className="mt-3">
            {!showInfoCrew ? (
              ""
                  ) : (
                    <InfoCrewCalls  /> 
                    ) } 
            </div>
            </Col>
          </Row>
          </div>
          {/* department buttons */}
          <div className={`mt-2 pt-2 px-2 ${styles.White }`}> 
            <Row className={`${styles.ButtonLine} mt-0`}>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowPro(showPro => !showPro)} > Production
                  </p>
              </Col>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() => setShowCam(showCam => !showCam)} > Camera
                      </p>
                  </Col>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowAD(showAD => !showAD)} > AD/PA
                </p>
              </Col>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
              <p
                  className={`py-0 mb-0 ${styles.Button}`}
                  onClick={() => setShowLoc(showLoc => !showLoc)} >Locations
              </p>
              </Col>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowWar(showWar => !showWar)} >Wardrobe
                </p>
              </Col>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowScr(showScr => !showScr)} > Script
                </p>
              </Col>
            </Row>  
            <Row className={`${styles.ButtonLine} text-center mt-1`}>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowEle(showEle => !showEle)} > Electric/Grip
                  </p>
              </Col>
              <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() => setShowMak(showMak => !showMak)} > Makeup
                      </p>
              </Col>
              <Col xs={4} sm={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowSou(showSou => !showSou)} > Sound
                </p>
              </Col>
              <Col xs={4} sm={4} md={2} className='mx-0 px-0 pt-1 text-center'>
              <p
                  className={`py-0 mb-0 ${styles.Button}`}
                  onClick={() => setShowStu(showStu => !showStu)} >Stunts/SFX
              </p>
              </Col>
              <Col xs={4} sm={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowArt(showArt => !showArt)} > Art
                </p>
              </Col>
              <Col xs={4} sm={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowPos(showPos => !showPos)} > Post/VFX
                </p>
              </Col>
            </Row> 
            {/* new row - Catering - Casting - Transport - Wrangling - TV Studio -Additional */}
            <Row className={`${styles.ButtonLine} mt-1`}>
            <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowCat(showCat => !showCat)} > Catering/Craft
                </p>
            </Col>
            <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowCas(showCas => !showCas)} > Casting
                </p>
            </Col>
            <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowTra(showTra => !showTra)} > Transport
                </p>
            </Col>
            <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`d-block d-md-none py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowWra(showWra => !showWra)} > Construction/Wr
                </p>
                <p
                    className={`d-none d-md-block py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowWra(showWra => !showWra)} > Construction/Wrangling
                </p>
            </Col>
            <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowTv(showTv => !showTv)} > TV Studio
                </p>
            </Col>
            <Col xs={4} md={2} className='mx-0 px-0 pt-1 text-center'>
                <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowAdd(showAdd => !showAdd)} >Additional
                </p>
            </Col>
            </Row> 
            <p className={`mt-1 pl-3 mb-0 pt-1 ${styles.SubTitle }`}></p>
            <div className={`py-1 ${styles.White }`}>
          </div>
          </div>
          {/* department components */}
          <div className={`mt-0 px-2 ${styles.Crew }`}>
            {/* Add Production */}
            {!showPro ? (
              ""
                  ) : (
                    <AddProduction postData={postData} handleChange={handleChange} 
                    crewInfoOne={crewInfoOne} setShowPro={setShowPro} /> 
            ) } 
            {/* Add Camera */}
            {!showCam ? (
                    ""
                  ) : (
                    <AddCamera crewInfoOne={crewInfoOne} setShowCam={setShowCam} 
                    postData={postData} handleChange={handleChange}/> 
            ) }  
            {/* Add AD/PA */}
            {!showAD ? (
                    ""
                  ) : (
                    <AddADPA crewInfoOne={crewInfoOne} setShowAD={setShowAD} 
                    postData={postData} handleChange={handleChange}/> 
            ) }
            {/* Add Locations */}
            {!showLoc ? (
                    ""
                  ) : (
                    <AddLocations crewInfoOne={crewInfoOne} setShowLoc={setShowLoc} 
                    postData={postData} handleChange={handleChange}/> 
            ) }
            {/* Add Wardrobe  */}
            {!showWar ? (
                    ""
                  ) : (
                    <AddWardrobe crewInfoOne={crewInfoOne} setShowWar={setShowWar} 
                    postData={postData} handleChange={handleChange}/> 
            ) } 
            {/* Add Script  */}
            {!showScr ? (
                    ""
                  ) : (
                    <AddScript crewInfoOne={crewInfoOne} setShowScr={setShowScr} 
                    postData={postData} handleChange={handleChange}/> 
                    ) } 
            {/* Add Electric */}
            {!showEle ? (
                    ""
                  ) : (
                    <AddElectricGrip crewInfoOne={crewInfoOne} setShowEle={setShowEle} 
                    postData={postData} handleChange={handleChange}/> 
                    ) } 
            {/* Add Makeup */}
            {!showMak ? (
                    ""
                  ) : (
                    <AddMakeup crewInfoOne={crewInfoOne} setShowMak={setShowMak} 
                    postData={postData} handleChange={handleChange}/> 
                    ) } 
            {/* Add Sound */}
            {!showSou ? (
                    ""
                  ) : (
                    <AddSound crewInfoOne={crewInfoOne} setShowSou={setShowSou} 
                    postData={postData} handleChange={handleChange}/> 
                    ) } 
            {/* Add Stunts */}
            {!showStu ? (
                    ""
                  ) : (
                    <AddStunts crewInfoOne={crewInfoOne} setShowStu={setShowStu} 
                    postData={postData} handleChange={handleChange}/> 
                    ) } 
            {/* Add Art */}
            {!showArt ? (
                    ""
                  ) : (
                    <AddArt crewInfoOne={crewInfoOne} setShowArt={setShowArt} 
                    postData={postData} handleChange={handleChange}/> 
                    ) } 
            {/* Add Post */}
            {!showPos ? (
                    ""
                  ) : (
                    <AddPost crewInfoOne={crewInfoOne} setShowPos={setShowPos} 
                    postData={postData} handleChange={handleChange}/> 
            ) } 
            {/* Add Catering */}
            {!showCat ? (
                    ""
                  ) : (
                    <AddCater crewInfoOne={crewInfoOne} setShowCat={setShowCat}
                    postData={postData} handleChange={handleChange} /> 
            ) } 
            {/* Add Casting */}
            {!showCas ? (
                    ""
                  ) : (
                    <AddCasting crewInfoOne={crewInfoOne} setShowCas={setShowCas}
                    postData={postData} handleChange={handleChange} /> 
            ) } 
            {/* Add Transport */}
            {!showTra ? (
                    ""
                  ) : (
                    <AddTransport crewInfoOne={crewInfoOne} setShowTra={setShowTra}
                    postData={postData} handleChange={handleChange} /> 
            ) } 
            {/* Add Construction/Wrangling */}
            {!showWra ? (
                    ""
                  ) : (
                    <AddConWrang crewInfoOne={crewInfoOne} setShowWra={setShowWra}
                    postData={postData} handleChange={handleChange} /> 
            ) } 
            {/* Add TV */}
            {!showTv ? (
                    ""
                  ) : (
                    <AddTv crewInfoOne={crewInfoOne} setShowTv={setShowTv}
                    postData={postData} handleChange={handleChange} /> 
            ) } 
            {/* Add Additional */}
            {!showAdd ? (
                    ""
                  ) : (
                    <AddAddition crewInfoOne={crewInfoOne} setShowAdd={setShowAdd}
                    postData={postData} handleChange={handleChange} /> 
            ) } 
            </div>
          {buttons}
          </Form>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default CallsheetEditPage;
